import { basePath } from './basePath';
export const logo = { uri: `${basePath ? `/${basePath}` : ''}/brand/logo.png` };
